module.exports = __webpack_public_path__ + "img/ft1.3833da6c.png";